import { APIClient } from "./apiCore";

// Create an instance of the APIClient
const api = new APIClient();

/**
 * Delete user account
 * @returns Promise with deletion result
 */
const deleteAccount = () => {
  return api.delete('/api/account');
};

export {
  deleteAccount,
}; 